import { Button, Typography } from '@breetometer/components';
import { ArrowIcon } from 'BreetAssets';
import { useCallback } from 'react';

import type { IPaginationShort } from './Pagination.helpers';

export const PaginationShort = ({ currentPage, pageLimit, totalDocItems, isLoading, onPageChange }: IPaginationShort) => {
	const handleNextCick = useCallback(() => {
		if (isLoading) return;
		onPageChange?.({
			currentPage: currentPage + 1,
			totalDocItems,
			pageLimit,
		});
	}, [currentPage, isLoading, onPageChange, totalDocItems, pageLimit]);

	const handlePreviousClick = useCallback(() => {
		if (isLoading) return;
		onPageChange?.({ currentPage: currentPage - 1, totalDocItems, pageLimit });
	}, [currentPage, isLoading, onPageChange, totalDocItems, pageLimit]);

	const start = totalDocItems === 0 ? 0 : (currentPage - 1) * pageLimit + 1;
	const end = totalDocItems === 0 ? 0 : Math.min(currentPage * pageLimit, totalDocItems);

	const rightDisableCheck = end === totalDocItems || isLoading;
	const leftDisableCheck = start === 1 || isLoading;

	return (
		<div className='pagination-short'>
			<Typography className='color-primary-50'>
				{start} - {end} of {totalDocItems.toLocaleString()}
			</Typography>
			<Button
				leadingIcon={<ArrowIcon variant='leftCaret' />}
				label=''
				variant='tertiary'
				disabled={leftDisableCheck}
				onClick={handlePreviousClick}
				className='color-neutral-50 theme-border-none'
			/>
			<Button
				leadingIcon={<ArrowIcon variant='rightCaret' />}
				label=''
				variant='tertiary'
				disabled={rightDisableCheck}
				onClick={handleNextCick}
			/>
			{isLoading && <div className='button-spinner' />}
		</div>
	);
};
